import { getApiBaseUrl, getBackendOrigin } from './apiConfig';

/** Origin for static files at `/uploads/...` (no `/api` prefix). */
export function getStaticOrigin(): string {
  return getBackendOrigin();
}

/** Resolve a stored `/uploads/...` path (or absolute URL) for <img src>. */
export function mediaUrl(path?: string | null): string | undefined {
  if (!path) return undefined;
  const trimmed = String(path).trim();
  if (!trimmed) return undefined;
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:')) return trimmed;
  // Production Apache only proxies `/api` to Node. Requesting `/uploads/...`
  // from the frontend host returns index.html (text/html) instead of the image.
  if (trimmed.startsWith('/uploads/') || trimmed === '/uploads') {
    return `${getApiBaseUrl()}${trimmed}`;
  }
  const origin = getStaticOrigin();
  return `${origin}${trimmed.startsWith('/') ? '' : '/'}${trimmed}`;
}
